<template>
  <v-card>
      <v-card-title>
          <v-layout justify-space-around wrap>
            <v-flex xs1>
              <v-btn
                icon
                color="primary"
                small
                @click="function () {
                  if (step === 1) $emit('fechar')
                  else step = 1
                }"
              >
                <v-icon>{{step !== 1 ? 'arrow_back' : 'close'}}</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs9>
              <h1 class="text-xs-center">{{titulo}}</h1>
            </v-flex>
            <v-flex xs1>
              <v-btn
                icon
                color="primary"
                small
                v-if="step===1"
                @click="step = 3"
              >
                <v-icon>list</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="step" style="box-shadow:none;">
          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0 ma-0">
              <v-layout justify-center>
                <v-icon size="100" color="primary">currency_exchange</v-icon>
              </v-layout>
              <p class="text-xs-center font-weight-bold mt-4 mb-1" style="font-size: 18px;">
                Digite o código do voucher
              </p>
              <v-text-field
                v-model="pesquisa"
                :loading="loading"
                box
                hide-details
                single-line
                color="primary"
                clearable
                class="centered-input display-1 font-weight-black mt-4"
                @input="pesquisa = $event.toUpperCase()"
              />
            </v-stepper-content>
            <v-stepper-content step="3" class="pa-0 ma-0">
              <v-list two-line dense>
                <template v-for="(voucher, index) in vouchersCashback">
                  <v-divider :key="`${index}d`"></v-divider>
                  <v-list-tile
                    :key="`${index}list`"
                    ripple
                  >
                    <v-list-tile-action>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-icon color="secondary">currency_exchange</v-icon>
                          </span>
                        </template>
                        <span>Voucher</span>
                      </v-tooltip>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="font-weight-bold">
                          {{ voucher.data_gerado ? voucher.data_gerado.split("-").reverse().join("/") : 'Data não disponível' }}
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-align: center" class="font-weight-bold">
                        R$ {{ parseFloat(voucher.valor).toFixed(2) }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon color="primary" small @click="abrirVoucher(voucher)">
                        <v-icon>visibility</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
              <div v-if="!vouchersCashback.length && !loading" class="text-xs-center grey--text mt-4">
                <div class="mt-2">Nenhum voucher encontrado.</div>
              </div>
              <v-layout justify-space-between v-if="pages > 1" class="mt-2">
                <v-flex xs1>
                  <v-btn
                    icon
                    small
                    @click="pagination.page--"
                    color="primary"
                    :disabled="pagination.page === 1"
                  >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs9>
                  <v-layout justify-center>
                    <v-avatar>
                      <v-btn icon small color="primary">
                        {{ pagination.page }}
                      </v-btn>
                    </v-avatar>
                  </v-layout>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    icon
                    small
                    @click="pagination.page++"
                    :disabled="pagination.page === pages"
                    color="primary"
                  >
                    <v-icon>arrow_forward</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-text v-if="step===2">
          <v-card class="mx-auto pa-4" flat style="font-size: 16px;">
            <v-layout row wrap align-start>
              <v-flex xs12 sm6 class="pl-5">
                <p><strong>Código:</strong> {{ voucherSelecionado.codigo }}</p>
                <p><strong>Valor:</strong> R$ {{ parseFloat(voucherSelecionado.valor).toFixed(2) }}</p>
                <p><strong>Data de geração:</strong> {{ voucherSelecionado.data_gerado.split("-").reverse().join("/") }}</p>
              </v-flex>
              <v-flex xs12 sm6 class="pl-5">
                <p>
                  <strong>Beneficiário:</strong>
                  {{ (voucherSelecionado.usuario_beneficiado && voucherSelecionado.usuario_beneficiado.pessoa && voucherSelecionado.usuario_beneficiado.pessoa.nome_completo) || 'Não informado' }}
                </p>
                <p>
                  <strong>Empresa vendedora:</strong>
                  {{ (voucherSelecionado.empresa_vendedora && voucherSelecionado.empresa_vendedora.razao_social) || 'Não informado' }}
                </p>
              </v-flex>
            </v-layout>
          </v-card>
          <v-layout justify-space-around wrap class="mb-2">
              <v-flex xs9>
                  <h6
                      class="mb-2 text-xs-center"
                      style="
                          font-size: 1.1em;
                          margin-left: 9em;
                      "
                  >
                      Digite o PIN do frentista responsável
                  </h6>
              </v-flex>
              <v-flex xs3>
                  <v-btn
                      round
                      color="primary"
                      small
                      @click="selecionarFrentista = true"
                  >
                      Alterar frentista
                  </v-btn>
              </v-flex>
              <v-flex xs2>
                  <v-icon size="40">engineering</v-icon>
              </v-flex>
              <v-flex xs10>
                  <h4>Lido por: {{frentistaSelecionado.nome}}</h4>
                  <h4>Matricula: {{frentistaSelecionado.matricula}}</h4>
              </v-flex>
          </v-layout>
          <Pin v-if="!autenticado" :frentista="frentistaSelecionado" @autenticado="autenticado = true"/>
          <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          block
          class="mb-1"
          :disabled="(step === 1 && !pesquisa) || (step === 2 && !autenticado)"
          @click="function () {
            if (step === 1) pegarVoucher()
            else lerVoucher()
          }"
          v-if="step !== 3"
        >
          <v-icon v-if="step===1" class="mr-1">search</v-icon>
          {{step === 1 ? 'Pesquisar' : 'Ler voucher'}}
        </v-btn>
      </v-card-actions>
      <v-dialog
          v-if="selecionarFrentista"
          v-model="selecionarFrentista"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
          <selecionar-frentista
              @fechar="selecionarFrentista = false, autenticado = false"
          />
      </v-dialog>
      <v-dialog v-model="dialogDetalhes" max-width="600px">
        <v-card v-if="voucherSelecionado">
          <v-card-title class="white--text primary" style="position: relative;">
            <div class="w-100 text-center font-weight-bold" style="font-size: 22px;">
              Detalhes do Voucher
            </div>
            <v-btn icon @click="dialogDetalhes = false" style="position: absolute; top: 8px; right: 8px;">
              <v-icon class="white--text">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-wrap pa-4" style="font-size: 16px;">
              <div style="width: 50%;" class="ml-4">
                <p><strong>Código:</strong> {{ voucherSelecionado.codigo }}</p>
                <p><strong>Valor:</strong> R$ {{ parseFloat(voucherSelecionado.valor).toFixed(2) }}</p>
                <p><strong>Beneficiário:</strong>
                  {{ voucherSelecionado.usuario_beneficiado && voucherSelecionado.usuario_beneficiado.pessoa && voucherSelecionado.usuario_beneficiado.pessoa.nome_completo || 'Não informado' }}
                </p>
                <p><strong>Data de geração:</strong> {{ voucherSelecionado.data_gerado.split('-').reverse().join('/') }}</p>
              </div>
              <div style="width: 50%;" class="ml-4">
                <p><strong>Empresa vendedora:</strong>
                  {{ voucherSelecionado.empresa_vendedora && voucherSelecionado.empresa_vendedora.razao_social || 'Não informado' }}
                </p>
                <p><strong>Data leitura:</strong>
                  {{ voucherSelecionado.data_inativado || 'Não informado' }}
                </p>
                <p><strong>Lido por:</strong>
                  {{ voucherSelecionado.frentista.nome }}
                </p>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-card>
</template>

<script>

import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'

export default {
  components: { Pin, SelecionarFrentista },
  data: () => ({
    step: 1,
    pesquisa: undefined,
    vouchersCashback: [],
    totalItens: 0,
    voucherSelecionado: undefined,
    dialogDetalhes: false,
    tabs: 0,
    selecionarFrentista: false,
    autenticado: false,
    pagination: {
      rowsPerPage: 5,
      page: 1
    }
  }),
  computed: {
    titulo () {
      if (this.step === 1) return 'Procurar por voucher'
      else if (this.step === 2) return 'Detalhes do voucher'
      else return 'Vouchers lidos'
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      let count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  watch: {
    pagination: {
      handler (val, oldval) {
        this.carregarVouchers()
      },
      deep: true
    },
    tabs () {
      this.pesquisa = undefined
    },
    step (val) {
      if (val === 3) this.carregarVouchers()
    }
  },
  methods: {
    abrirVoucher (voucher) {
      this.voucherSelecionado = voucher
      this.dialogDetalhes = true
    },
    selectVoucher (voucher) {
      this.voucherSelecionado = voucher
      this.step++
    },
    pegarVoucher () {
      const data = {
        codigo: this.pesquisa,
        empresa: this.frentistaSelecionado.empresa.cnpj,
        id_frentista: this.frentistaSelecionado.id_frentista
      }
      this.$store.dispatch('pegarVoucherCashpostoEmpresa', data)
        .then((voucher) => {
          if (voucher) {
            this.voucherSelecionado = voucher
            this.step++
          } else {
            this.voucherSelecionado = undefined
          }
        })
    },
    lerVoucher () {
      const data = {
        id_voucher: this.voucherSelecionado.id_voucher,
        cpf: this.voucherSelecionado.usuario_beneficiado.pessoa.cpf,
        empresa: this.frentistaSelecionado.empresa.cnpj,
        id_frentista: this.frentistaSelecionado.id_frentista
      }
      this.$store.dispatch('lerVoucherCashpostoEmpresas', data)
        .then(() => {
          this.voucherSelecionado = undefined
          this.step = 1
        })
    },
    carregarVouchers () {
      const data = {
        id_frentista: this.frentistaSelecionado.id_frentista,
        empresa: this.frentistaSelecionado.empresa.cnpj,
        page: this.pagination.page,
        page_size: this.pagination.rowsPerPage
      }
      this.$store.dispatch('historicoVoucherCashpostoEmpresa', data)
        .then((json) => {
          if (json) {
            this.vouchersCashback = json.results.vouchers
            this.totalItens = json.count
          } else {
            this.vouchersCashback = []
            this.totalItens = 0
          }
        })
    }
  }
}
</script>
